module.exports = __webpack_public_path__ + "img/SWIFT_REPLAY_30s.180b1512.jpg";